import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=1778dc52&scoped=true&"
import script from "./Tr.vue?vue&type=script&lang=ts&"
export * from "./Tr.vue?vue&type=script&lang=ts&"
import style0 from "./Tr.vue?vue&type=style&index=0&id=1778dc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778dc52",
  null
  
)

export default component.exports